/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class MixSpecificationProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the MixSpecification by ID
	 * @param {String|Number} pMixSpecificationID - The MixSpecification ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getMixSpecificationByID(pMixSpecificationID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pMixSpecificationID)
			{
				this.pict.log.error('No MixSpecification ID provided.');
				return reject(new Error('No MixSpecification ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`MixSpecification/${pMixSpecificationID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting MixSpecification: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = MixSpecificationProvider;
module.exports.default_configuration = {};
